<template>
    <div class="">
        <div v-show="currentUser.is_superuser || currentUser.is_ventura_admin" class="container" v-if="loading">
            <div class="fl-eq mt-4">
                <loading-animation/>
            </div>
        </div>

        <div v-show="currentUser.is_superuser || currentUser.is_ventura_admin" class="container" v-else-if="error">
            <div class="card bg-danger fl-te-c">
                <div>
                    <error-icon/>
                    Failed to load data from the server.
                </div>
                <div>
                    <a class="pointer" @click="loadData()"><i class="fa fa-refresh"></i> reload</a>
                </div>
            </div>
        </div>

        <inner-page-card v-if="!loading" design="basic-b" class="bs-3" :link-back="true" heading="Enquiry Details">
            <div v-if="currentUser.is_superuser || currentUser.is_ventura_admin" class="row">
                <div class="col-12">
                    <section>
                        <div class="p-4">
                            <div class="row">
                                <div v-if="details.name" class="col-lg-4 col-6">
                                    <h6 class="font-inter-medium fs-2">Name </h6>
                                    <p class="font-inter-regular fs-1">{{ details.name }}</p>
                                </div>

                                <div v-if="details.email" class="col-lg-4 col-6 mt-3">
                                    <h6 class="font-inter-medium fs-2">E-Mail </h6>
                                    <p class="fs-1 font-inter-regular">{{ details.email }}</p>
                                </div>

                                <div v-if="details.phone" class="col-lg-4 col-6 mt-3">
                                    <h6 class="font-inter-medium fs-2">Phone </h6>
                                    <p class="fs-1 font-inter-regular">{{ details.phone }}</p>
                                </div>

                                <div v-if="details.auction" class="col-lg-4 col-6 mt-3">
                                    <h6 class="font-inter-medium fs-2">Auction ID</h6>
                                    <p class="fs-1 font-inter-regular">{{ details.auction.auction_id }}</p>
                                </div>

                                <div v-if="details.auction" class="col-lg-4 col-6 mt-3">
                                    <h6 class="font-inter-medium fs-2">Auction Name</h6>
                                    <p class="fs-1 font-inter-regular">{{ details.auction.title }}</p>
                                </div>

                                <div v-if="details.created_date" class="col-lg-4 col-6 mt-3">
                                    <h6 class="font-inter-medium fs-2">Enquired On </h6>
                                    <p class="fs-1 font-inter-regular">{{ details.created_date }}</p>
                                </div>

                                <div v-if="details.is_third_party" class="col-lg-4 col-6 mt-3">
                                    <h6 class="font-inter-medium fs-2">Platform </h6>
                                    <p class="fs-1 font-inter-regular" v-if="details.is_third_party">
                                        Bank e Auctions India.com
                                    </p>
                                    <p class="fs-1 font-inter-regular" v-else>Other</p>
                                </div>

                                <div v-if="details.request_call_back" class="col-lg-4 col-6 mt-3">
                                    <h6 class="font-inter-medium fs-2">Request call back </h6>
                                    <p class="fs-1 font-inter-regular" v-if="details.request_call_back">Yes</p>
                                    <p class="fs-1 font-inter-regular" v-else>No</p>
                                </div>

                                <div v-if="details.query" class="col-12 mt-4">
                                    <h6 class="font-inter-medium fs-2">Query</h6>
                                    <p class="font-inter-regular fs-1">{{ details.query }}</p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

            </div>
            <div v-else class="text-center py-7">
                <h4 class="font-inter-bold">Permission Denied!</h4>
                <p class="">Sorry, You have no permission to view this page.</p>
            </div>
        </inner-page-card>

    </div>
</template>

<script>
import axios from 'secure-axios';
import urls from '@/data/urls';
import { mapGetters } from 'vuex';

export default {
    name : 'EnquiryDetails',

    data () {
        return {
            id      : this.$route.params.id,
            details : '',
            error   : false,
            loading : true
        };
    },

    computed : {
        ...mapGetters(['currentUser'])
    },

    mounted () {
        this.loadData();
    },

    methods : {
        loadData () {
            const that = this;
            that.loading = true;
            const model = {
                id : that.id
            };
            axios.form(urls.userList.enquiryDetails, model).then(function (response) {
                const json = response.data;
                if (json.error === false) {
                    that.details = { ...json.data };
                    that.loading = false;
                } else {
                    that.loading = false;
                }
            }).catch(function (exception) {
                console.log('Exception at the incident details loading => ', exception);
                that.loading = false;
            });
        }
    }
};
</script>

<style scoped>

.bg-blue-layer {
    background: url("../../assets/web/bg/blue-strip-alternate.jpg");
}

.c-margin-x {
    margin: -15px -15px 0 -15px;
}

.icon-md {
    height: 2.5rem !important;
}

</style>
